import { Skeleton } from '@mui/material';

const SliderSkeleton = () => {
  return <Skeleton variant="rounded" height={24} width="100%" />;
};

export default SliderSkeleton;
